import React, { useState, useEffect } from "react";
import { Container, OverlayTrigger, Popover, FormCheck } from "react-bootstrap";
import { FaMobileAlt, FaAddressCard, FaEnvelope } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineRight } from "react-icons/ai";
import { useTranslation } from 'react-i18next';
import { TENANT_BUCKET, USER_VERIFICATION_DATA } from '../../common/constants'
import PageTitle from '../pageTitle/default.js';
import Alert from '../../components/Alert';
import { useMiddletier } from "../../common/middletier";
import { useStoreDispatch, useStoreState, APP_STORE_ACTION } from '../../common/storeContext';
import "./template_01.css";




const MyProfile = (props) => {
    const appDispatch = useStoreDispatch()
    const appState = useStoreState()
    const navigate = useNavigate();
    const { mobileTitleToggle } = props;
    const { mutation, queries } = useMiddletier();
    const [affiliateGroupImage, setAffiliateGroupImage] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
    
        queries([{
            method: 'getAffiliateGroup',
            params: [
              { code: 'filter', graphqlType: 'JSON', required: true, value: { where: { id: appState.user?.affiliate_group ?? 'DEFAULT' } } }
            ],
            attributes: [['_logo', ['url']]]

        }]).then(({ data }) => {

            setAffiliateGroupImage(data['getAffiliateGroup']?.[0]?._logo ? data['getAffiliateGroup']?.[0]?._logo.url : `${TENANT_BUCKET}/icon/wallet_user.png`)

        }).catch((error) => {
            console.log('error: ', error)
            if (error?.networkError?.statusCode === 401) {
                appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })
              } else {
                appDispatch({
                  type: APP_STORE_ACTION.SHOW_ALERT,
                  payload: { description: error.message.toString(), typeAlert: 'error' }
                });
              }
        })

    }, [appState.user, queries, navigate, appDispatch]);

    return (
        <>
            <section id="profileMobile_01">
                <div className="myProfile_body">
                    <PageTitle mobileToggle={mobileTitleToggle} title={"My Profile"} onlyBackButton={true} id={"myProfile_title"} />
                    <Container className="myProfile_container">
                        <section className="myProfile_info">
                            <div className="myProfile_info_user">
                                {affiliateGroupImage !== '' && (<img src={`${affiliateGroupImage}`} alt={'wallet user'} />)}
                                <label>{appState.user?.username}</label>
                            </div>
                            {/* <div className="myProfile_info_reward">
                                <div className="color_primary myProfile_info_token">
                                    <img src={`${TENANT_BUCKET}/icon/token.png`} alt={'token'} />
                                    <label>2568 Tokens</label>
                                </div>
                                <div className="color_primary myProfile_info_point">
                                    <img src={`${TENANT_BUCKET}/icon/point.png`} alt={'point'} />
                                    <label>2568 Points</label>
                                </div>
                            </div> */}
                        </section>
                        {/* <section className="myProfile_mySetting">
                            <div className="subTitle myProfile_subTitle">{t('my_setting')}</div>
                            <div className="color_primary myProfile_mySetting_row">
                                <label>{t('user_verification')}</label>
                                <div className="d-flex align-items-center">
                                    {USER_VERIFICATION_DATA.map(function (item, index) {
                                        const _item = appState?.user?.[item.id]
                                        return (
                                            <div key={item.id}>
                                                <OverlayTrigger
                                                    trigger="click"
                                                    key={'bottom'}
                                                    placement={'bottom'}
                                                    overlay={
                                                        <Popover>
                                                            <Popover.Body>
                                                                {_item ? (t(`${item.name}_verifed_content`)) : (t(`${item.name}_unverifed_content`))}
                                                            </Popover.Body>
                                                        </Popover>
                                                    }
                                                >
                                                    <div className={`verify_icon ${_item ? 'validated' : ''}`}>
                                                        {item.name === 'phone_number' ? <FaMobileAlt /> : (item.name === 'email' ? <FaEnvelope /> : (item.name === 'dob' ? <FaAddressCard /> : <></>))}
                                                    </div>
                                                </OverlayTrigger>

                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className="color_primary myProfile_mySetting_row">
                                <label>{t('auto_transfer')}</label>
                                <div>
                                    <FormCheck custom type="switch">
                                        <FormCheck.Input isInvalid checked={appState.user?.auto_restore} onClick={() => onChangeAutoTransfer()} />
                                    </FormCheck>
                                </div>
                            </div>
                        </section> */}
                               <section className="myProfile_myAccount">
                            <div className="subTitle myProfile_subTitle">{t('funds')}</div>
                            <Link to="/wallet/deposit" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/bankingInfo_menu_deposit_active.png`} alt={'deposit'} />
                                    <label>{t('deposit')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            <Link to="/wallet/transfer" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/bankingInfo_menu_transfer_active.png`} alt={'transfer'} />
                                    <label>{t('transfer')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            {/* <Link to="/wallet/change_game_password" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_changeGamePassword.png`} alt={'change game password'} />
                                    <label>{t('change_game_password')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link> */}
                            <Link to="/wallet/withdraw" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal_active.png`} alt={'withdraw'} />
                                    <label>{t('withdraw')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            <Link to="/wallet/report" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/bankingInfo_menu_report_active.png`} alt={'report'} />
                                    <label>{t('report')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                        </section>
                        <section className="myProfile_myAccount">
                            <div className="subTitle myProfile_subTitle">{t('my_account')}</div>
                            <Link to="/wallet/user_info" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_userInfo.png`} alt={'user info'} />
                                    <label>{t('user_info')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            <Link to="/wallet/change_password" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_changePassword.png`} alt={'change password'} />
                                    <label>{t('change_password')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                            {/* <Link to="/wallet/change_game_password" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_changeGamePassword.png`} alt={'change game password'} />
                                    <label>{t('change_game_password')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link> */}
                            <Link to="/wallet/banking_details" className="color_primary myProfile_myAccount_row">
                                <div className="d-flex align-items-center">
                                    <img src={`${TENANT_BUCKET}/icon/myProfile_bankingDetails.png`} alt={'banking details'} />
                                    <label>{t('banking_details')}</label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <AiOutlineRight />
                                </div>
                            </Link>
                        </section>
                    </Container>
                </div>
            </section>
        
        </>

    );




};






export default MyProfile;
